import styles from './ContentDarkBackground.module.scss'

export default function ContentDarkBackground(props) {
  const { subheading, heading, description } = props.fields

  return (
    <div className={styles.contentDarkBackground}>
      <div className={styles.contentDarkBackgroundWrapper}>
        <div className={styles.contentDarkBackgroundMainContent} data-aos="fade-up">
          <p className={styles.subheading}>{subheading}</p>
          <h3 className={styles.heading}>{heading}</h3>
          <div className={styles.WYSIWYGWrapper}>
            <div
              className={styles.WYSIWYG}
              dangerouslySetInnerHTML={{
                __html: description
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  )
}
